import { render, staticRenderFns } from "./jobfuture.vue?vue&type=template&id=4f804adb&scoped=true&"
import script from "./jobfuture.vue?vue&type=script&lang=js&"
export * from "./jobfuture.vue?vue&type=script&lang=js&"
import style0 from "./jobfuture.vue?vue&type=style&index=0&id=4f804adb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f804adb",
  null
  
)

export default component.exports